import theme from '../../../../lib/theme';
import { MembershipSignupPanelProps } from './MembershipSignupPanel';

const { layouts, scale, colors, media } = theme;

export default ({joinBackgroundImage}: MembershipSignupPanelProps) => ({
  container: {
    ...layouts.column,
    color: colors.sas.primary_dark,
    alignItems: 'center',
    padding: '0',
    paddingTop: '0 !important', // override default padding
    background:
      `url(${joinBackgroundImage}) repeat`,
    marginTop: '0 !important',
  },

  signUpContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    // padding: `${scale.s} ${scale.xs} 0`,

    [media.s.down]: {
      flexDirection: 'column',
      // padding: `${scale.s} ${scale.xs}`,
    },

  },

  signupPicture: {
    flex: '0 0 30%',
    display: 'flex',
    alignItems: 'flex-end',

    [media.s.down]: {
      justifyContent: 'center',
    },

    img: {
      height: '100%',
      maxHeight: '100%',
      width: 'auto',

      [media.s.down]: {
        width: '50% !important',
      },
    },
  },

  signupText: {
    flex: '0 0 50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    padding: `${scale.s} ${scale.s} ${scale.xs}`,

    [media.l.down]: {
      flex: '0 0 70%',
    },

    [media.s.down]: {
      flex: '1 0 100%',
    }
  },

  button: {
    color: '#ffffff',
    backgroundColor: colors.sas.primary,
    padding: '5px 21px',
    height: 'auto',
  },

  // Membership Block Styles
  section: {
    ...layouts.column,
    backgroundColor: 'transparent',

    alignItems: 'center',
    padding: scale.xs,
  },

  formGroupContainer: {
    ...layouts.column,
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: `${scale.xxxs}`,
  },

  formGroup: {
    ...layouts.row,
    flex: `1 0 calc(100% - 1rem)`,
    width: '100%',
    maxWidth: '100%',

    '> label': {
      textAlign: 'left',
      padding: `4px 0`,
      flex: `0 0 30%`,
    },
  },

  controlsContainer : {
    padding: `${scale.s} 0 0 !important`,
    marginTop: '0 !important',
  },

  alert: {
    fontSize: '1.1rem !important',
    width: '100%',
    margin: `${scale.xs} 0 0 !important`,
  },

  dobGroup: {
    'div': {
      display: 'flex',

      [media.l.down]: {
        maxWidth: `75%`,  
      },

      [media.s.down]: {
        maxWidth: `100%`,  
      },
    },
  },

  '.form-control': {
    padding: `10px ${scale.xs} !important`,
  },

  dobContainer: {
    gap: '0.5rem',

    '> *': {
      flex: '1',
    },
  },


});